"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2720],{

/***/ 41914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ UseCasesDriveGrowth_UseCasesDriveGrowth; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/UseCasesDriveGrowth/UseCasesDriveGrowth.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var features = [{
  heading: "Acquisition",
  description: "Use first-party data to better target leads, optimize campaigns, and be more efficient with your ad spend.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* UserIcon */.tB, {})
}, {
  heading: "Conversion",
  description: "Easily design personalized, multi-channel communications to drive customers towards purchase with the right message at the right time.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* EngagingIcon */.h, {})
}, {
  heading: "Retention",
  description: "Reactivate dormant customers and keep high-value customers engaged by consistently creating meaningful connections with them.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* RetainingIcon */.Ys, {})
}];
var copy = {
  heading: "Use cases",
  description: "Drive efficient growth across the entire customer journey"
};
var UseCasesDriveGrowth = function UseCasesDriveGrowth() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            variant: "h2",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          columns: 1,
          overrides: {
            md: 3
          },
          children: features.map(function (feature, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledFeatureBoxBase, {
              alignment: "left",
              headerPosition: "top",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledIconWrapper, {
                  variant: "circle",
                  background: "light",
                  elevation: 1,
                  children: feature.icon
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: feature.heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  children: feature.description
                })]
              })]
            }, index);
          })
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebc7yl44"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ebc7yl43"
} : 0)( true ? {
  name: "1fygc5t",
  styles: "max-width:1280px"
} : 0);

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "ebc7yl42"
} : 0)( true ? {
  name: "1ib8u6k",
  styles: "max-width:844px"
} : 0);

var StyledIconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(IconWrapper/* default */.Z,  true ? {
  target: "ebc7yl41"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

var StyledFeatureBoxBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* default */.ZP,  true ? {
  target: "ebc7yl40"
} : 0)("max-width:350px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{max-width:unset;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{padding:0 15px;}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xxl");
}, "{padding:24px 15px;}" + ( true ? "" : 0));

/* harmony default export */ var UseCasesDriveGrowth_UseCasesDriveGrowth = (UseCasesDriveGrowth);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/UseCasesDriveGrowth/index.ts


/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ })

}]);